import { render, staticRenderFns } from "./Viewer3d.vue?vue&type=template&id=f3b00b8a&scoped=true"
import script from "./Viewer3d.vue?vue&type=script&lang=js"
export * from "./Viewer3d.vue?vue&type=script&lang=js"
import style0 from "./Viewer3d.vue?vue&type=style&index=0&id=f3b00b8a&prod&lang=scss&scoped=true"
import style1 from "./Viewer3d.vue?vue&type=style&index=1&id=f3b00b8a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b00b8a",
  null
  
)

export default component.exports